import React from 'react';
import { Box, Rating, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface RatingDisplayProps {
    averageRating: number | null;
    ratingCount: number;
    size?: 'small' | 'medium' | 'large';
    showCount?: boolean;
}

const RatingDisplay: React.FC<RatingDisplayProps> = ({
    averageRating,
    ratingCount,
    size = 'small',
    showCount = true,
}) => {
    if (averageRating === null || ratingCount === 0) {
        return null;
    }

    const fontSize = size === 'small' ? '0.875rem' : size === 'medium' ? '1rem' : '1.25rem';
    const ratingSize = size === 'small' ? 'small' : size === 'medium' ? 'medium' : 'large';

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Rating
                value={averageRating}
                precision={0.1}
                size={ratingSize}
                readOnly
                emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
            />
            {showCount && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize, whiteSpace: 'nowrap' }}
                >
                    {averageRating.toFixed(1)} ({ratingCount})
                </Typography>
            )}
        </Box>
    );
};

export default RatingDisplay;
